import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { FAQCategory } from '@/types/faq'
import { faqsApi } from '@/services/api/faqs'

interface FAQCategoriesState {
    categories: FAQCategory[]
    isLoading: boolean
    error: string | null
}

const initialState: FAQCategoriesState = {
    categories: [],
    isLoading: false,
    error: null,
}

// ===== ASYNC THUNKS =====

export const fetchFAQCategories = createAsyncThunk(
    'faqCategories/fetchCategories',
    async (_, { rejectWithValue }) => {
        try {
            const response = await faqsApi.getCategories()
            return response.data.data || []
        } catch (error: any) {
            const message = error.response?.data?.message || 'Failed to fetch FAQ categories'
            return rejectWithValue(message)
        }
    }
)

// ===== SLICE =====

const faqCategoriesSlice = createSlice({
    name: 'faqCategories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFAQCategories.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchFAQCategories.fulfilled, (state, action) => {
                state.isLoading = false
                state.categories = action.payload
                state.error = null
            })
            .addCase(fetchFAQCategories.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload as string
            })
    },
})

export default faqCategoriesSlice.reducer